import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { ShippingMethod } from '../../../core/enums/woo-commerce/shipping/shipping.enum';
import {
  SetAvailableShippingMethodsAction,
  UpsertShippingAction
} from './shipping.actions';
import {
  WooCommerceDeliveryAddress,
  WooCommerceShippingAddress
} from '../../../core/interfaces/woo-commerce/api/woo-commerce-api.interface';
import { WooCommerceDatetimeTimeSlotValue } from '../../../core/enums/woo-commerce/api/woo-commerce-api.enum';
import { ShippingOption } from '../../../modules/checkout/models/delivery-methods';

export interface ShippingStateModel {
  address?: WooCommerceDeliveryAddress | WooCommerceShippingAddress;
  method?: ShippingMethod;
  methodDetails?: string;
  schedule?: ShippingScheduleStateModel;
  availableShippingMethods?: ShippingOption[];
  selectedShippingMethod?: ShippingOption;
}

export interface ShippingScheduleStateModel {
  date: Date;
  time: Date | WooCommerceDatetimeTimeSlotValue | string;
  timestamp: number;
}

const defaults = {
  address: undefined,
  method: undefined,
  methodDetails: undefined,
  schedule: undefined,
  availableShippingMethods: undefined,
  selectedShippingMethod: undefined
};

@State<ShippingStateModel>({
  name: 'shipping',
  defaults
})
@Injectable()
export class ShippingState {
  @Selector()
  static shippingState(state: ShippingStateModel) {
    return state;
  }

  @Selector()
  static availableShippingMethods(state: ShippingStateModel) {
    return state.availableShippingMethods || [];
  }

  @Selector()
  static selectedShippingMethod(state: ShippingStateModel) {
    return state.selectedShippingMethod;
  }

  @Selector()
  static schedule(state: ShippingStateModel) {
    return state.schedule;
  }

  @Action(UpsertShippingAction)
  upsertShipping(
    ctx: StateContext<ShippingStateModel>,
    { payload }: UpsertShippingAction
  ) {
    ctx.patchState(payload);
  }

  @Action(SetAvailableShippingMethodsAction)
  setAvailableShippingMethods(
    ctx: StateContext<ShippingStateModel>,
    { payload }: SetAvailableShippingMethodsAction
  ) {
    ctx.patchState({
      availableShippingMethods: payload.availableShippingMethods,
      selectedShippingMethod: payload.selectedShippingMethod
    });
  }
}
